import PermessionManagement from './permession_management'

export default {
  "permession_management": PermessionManagement
}



// WEBPACK FOOTER //
// ./src/pages/permession_management/index.js